import { h, render, Component } from 'preact';
import root from 'window-or-global';
import Cookies from 'universal-cookie';
import Button from 'q-mdc/elements/material-button';
import MyAccountMenu from 'q-components/components/myAccount';
import {
  HOME_PATH_REGEX,
  SNB_PATH_REGEX,
  VAP_PATH_REGEX,
  POST_AD_S1_PATH_REGEX,
  GUARANTEEDJOBS_PATH_REGEX,
  RECRUITMENT_ASSIST_LINK_PATH_REGEX,
  JOBS_404,
  FLEXI_CANDIDATE_REGISTER,
  FLEXI_RECRUITER_RMT_REPORT,
  CANDIDATE_TEST_LINK_PATH_REGEX,
  FLEXI_CANDIDATE_RMT_DATA_CAPTURE,
  FLEXI_CANDIDATE_PROFILE,
  UPGRADE_AD
} from './constants/url';
import {
  TOP_ROLES, LOGGEDOUT_MENU, LOGGEDIN_MENU, ROUTES
} from '../src/constants';
import { GA_ACCOUNT_ID, GA_TRACKER_NAME } from './constants/ga';
import UrlBuilder from './utils/Search/UrlBuilder';
import { firePageLoadGa } from './utils/GaHelper';
import FetchHelper from './utils/FetchHelper';
import { updateInterstitialConfig, copyObject } from './utils';
import getPageType from 'rum-pagetypes/src';
import Context from './utils/Context';
import CustomEventService from './utils/CustomEventService';
import CandidateTestUtils from './utils/CandidateTest';
import { defaultFilters } from './reducers/SnbReducer/filter';
import { setFiltersFromUrl } from './utils/Filter';
import { getSearchResultsPromise } from './utils/Search';
import { updateFilterState } from './actions/SnbContainerActions';
import { updateWindowData } from './actions/windowActions';


let suggestions = null;

function handlePostAdClick() {
  if (root.location) {
    root.location.href = '/jobs/post-ad-jobs';
  }
}

function searchPlaceHolder() {
  const urlBuilder = new UrlBuilder();
  const params = {};
  const snbParams = root.location && urlBuilder.parseSnbUrl(root.location.pathname);
  if (snbParams && snbParams.role && snbParams.role.length > 0) {
    params.role = snbParams.role[0];
  }
  if (snbParams && snbParams.keyword && snbParams.keyword.length > 0) {
    params.keyword = snbParams.keyword[0];
  }

  const searchPlaceHolder = params.role
    ? params.role
    : params.keyword
      ? params.keyword
      : 'Search in Jobs';

  return searchPlaceHolder;
}

export const setCityCookies = (cityId, cityName) => {
  let cookies = new Cookies();
  if (!cityName || typeof cityName === 'undefined' || cityName === 'undefined'
    || !cityId || typeof cityId === 'undefined' || cityId === 'undefined') {
    if (getCurrentCity() === 'undefined' || getCurrentCityId() === 'undefined') {
      cookies.set('new_prefer_city', 'www', { path: '/', domain: '.quikr.com' });
      cookies.set('prefer_city_id', '1', { path: '/', domain: '.quikr.com' });
      cookies.set('new_prefer_city_id', '1', { path: '/', domain: '.quikr.com' });
    }
    return;
  }

  if (getCurrentCity() || getCurrentCityId()) {
    if (cityName.indexOf('x:') > -1) {
      // if abroad cities are selected, set the cookie with /jobs as path
      // so that quikr homepage does not redirect to {cityName}.quikr.com
      // and unset the cookies with / as path and domain other than .quikr.com
      cookies.set('new_prefer_city', cityName.replace('x:',''), { path: '/jobs', domain: '.quikr.com' });
      cookies.set('new_prefer_city_id', cityId, { path: '/jobs', domain: '.quikr.com' });

      cookies.set('new_prefer_city', cityName.replace('x:',''), { path: '/', domain: '.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city', cityName.replace('x:',''), { path: '/', domain: 'www.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city', cityName.replace('x:',''), { path: '/jobs', domain: 'www.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city_id', cityId, { path: '/', domain: '.quikr.com', expires: new Date(0) });
      cookies.set('prefer_city_id', cityId, { path: '/', domain: '.quikr.com', expires: new Date(0) });
    } else {
      // if indian cities are selected, set the cookie with / as path
      // and unset the cookies with /jobs as path and domain other than .quikr.com
      cookies.set('new_prefer_city', cityName.replace('x:',''), { path: '/', domain: '.quikr.com' });
      cookies.set('new_prefer_city_id', cityId, { path: '/', domain: '.quikr.com' });
      cookies.set('prefer_city_id', cityId, { path: '/', domain: '.quikr.com' });

      cookies.set('new_prefer_city', cityName.replace('x:',''), { path: '/jobs', domain: '.quikr.com', expires: new Date(0)});
      cookies.set('new_prefer_city', cityName.replace('x:',''), { path: '/', domain: 'www.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city', cityName.replace('x:',''), { path: '/jobs', domain: 'www.quikr.com', expires: new Date(0) });
      cookies.set('new_prefer_city_id', cityId, { path: '/jobs', domain: '.quikr.com', expires: new Date(0)});
    }
  }
};

function searchCityCallback(cityId, cityName, globalId, match) {
  setCityCookies(cityId, cityName);

  if (root.location && root.location.pathname.replace(/\//g,'') === 'jobs') {
    root.location.reload();
  } else {
    const urlBuilder = new UrlBuilder();
    const params = { cityName };
    const snbParams = root.location && urlBuilder.parseSnbUrl(root.location.pathname);
    if (snbParams && snbParams.role && snbParams.role.length > 0) {
      params.role = snbParams.role[0];
    }

    if (root.location) {
      root.location.href = urlBuilder.getJobsSnbUrl(params);
    }
  }
}

function onSearchSubmit (keyword) {
  if (!keyword || keyword === '') {
    return;
  }

  const cityName = getCurrentCity();
  let urlBuilder = new UrlBuilder();
  let params = { keyword, cityName };
  let url = urlBuilder.getJobsSnbUrl(params);

  root.location.href = url;
  firePageLoadGa('applyFilter',{pwa_candidate: 'freetextwosuggest'});
  if (typeof dataLayer != 'undefined') {
    dataLayer.push({'event': 'search', 'platform': 'pwa'});
  }
}

function onSearchCallback(event, updateSearchSuggestions, defaultSearchHandler) {
  let searchText = event.target.value;

  if (searchText && searchText !== '') {
    let fetchHelper = new FetchHelper();
    let params = {
      url: root.location.protocol + '//www.quikr.com/jobs/jobsAjax/roleSearch?keyword=' + searchText
    };

    let suggestionsPromise = fetchHelper.request('get', params);

    suggestionsPromise.then((response) => {
      let data = (response.data) ? response.data : {};
      if (data.success) {
        data = sortSearchResults(data.json, searchText);
        suggestions = getCustomSearchResults(data);
        updateSearchSuggestions(suggestions);
      }
    });
  } else {
    suggestions = null;
    updateSearchSuggestions(suggestions);
  }
}

function getCustomSearchResults(searchItems) {
  searchItems = searchItems ? searchItems : null;

  let title = 'Search Roles';
  if (!searchItems || searchItems.length === 0) {
    searchItems = [];
    TOP_ROLES.forEach((value, i) => {
      searchItems.push({ role: value.name });
    });
    title = 'Top Roles';
  }

  return getRoleItemElements(searchItems, title);
}

function getRoleItemElements(searchItems, title) {
  let searchList = [];
  searchItems.forEach((value, i) => {
    searchList.push(
      <li class="mdc-list-item" onClick={doRoleSearch}>{value.role}</li>
    );

    if (value.suggestedSubrole) {
      value.suggestedSubrole.forEach((subrole, i) => {
        searchList.push(
          <li class="mdc-list-item" onClick={doRoleSearch}
              data-href={subrole.url}
              style="padding-left: 20px;font-size: 0.85rem;">{subrole.subrole}</li>
        );
      });
    }
  });

  return (
    <div>
      <h5>{title}</h5>
      <ul class="mdc-list">
        {searchList}
      </ul>
    </div>
  );
}

function doRoleSearch(event) {
  let url = event.target.getAttribute('data-href');
  let keyword = event.target.innerHTML;
  pushToRecentSearches(keyword);

  if (url) {
    root.location.href = url;
  } else {
    let urlBuilder = new UrlBuilder();

    const cityName = getCurrentCity();

    let params = { city: cityName, role: keyword };
    url = urlBuilder.getJobsSnbUrl(params);
    root.location.href = url;
  }
  if(typeof dataLayer != 'undefined') {
    dataLayer.push({'event': 'search', 'platform': 'pwa'});
  }
  firePageLoadGa('applyFilter',{pwa_candidate: 'freetextsuggest'});
}

function pushToRecentSearches(value) {
  // Add the search to recent searches
  if (root.localStorage) {
    let recentSearches = localStorage.getItem('recentSearches');
    if (recentSearches) {
      recentSearches = recentSearches.split(',');
    } else {
      recentSearches = [];
    }
    // find the current value in recent searches,
    // if it exists delete it
    // or else if the length >= 3 then delete the last element
    const index = recentSearches.indexOf(value);
    if (index >= 0) {
      recentSearches.splice(index, 1);
    } else if (recentSearches.length >= 3) {
      recentSearches.pop();
    }
    // push the current value at the end
    recentSearches.unshift(value);
    localStorage.setItem('recentSearches', recentSearches);
  }
}

function sortSearchResults(data, searchText) {
  searchText = searchText.toLowerCase();

  data = data.sort(function(item1, item2) {
    let dataValue1 = item1['role'].toLowerCase();
    let indexOfDataValue1 = dataValue1.indexOf(searchText);
    indexOfDataValue1 = indexOfDataValue1 === -1 ? Number.MAX_SAFE_INTEGER : indexOfDataValue1;
    let dataValue2 = item2['role'].toLowerCase();
    let indexOfDataValue2 = dataValue2.indexOf(searchText);
    indexOfDataValue2 = indexOfDataValue2 === -1 ? Number.MAX_SAFE_INTEGER : indexOfDataValue2;

    if (indexOfDataValue1 < indexOfDataValue2) {
      return -1;
    } else if(indexOfDataValue1 > indexOfDataValue2) {
      return 1;
    } else {
      if (dataValue1 < dataValue2) {
        return -1;
      } else if (dataValue1 > dataValue2) {
        return 1;
      }
    }

    return 0;
  });

  return data;
}

function handleVapBackClick (event, history) {
  if (history.length > 1) {
    history.goBack();
  } else {
    if (history.location.pathname) {
      const cityName = getCurrentCity();

      const urlBuilder = new UrlBuilder();
      const params = { city: cityName };

      if (typeof JobSnow !== 'undefined') {
        JobSnow.route = ROUTES.SNB;
        JobSnow.isInterstialAdEnabled = Context.isInterstitialAdEnabled('snbPWA', cityName);
        JobSnow.isFlyingCarpetAdEnabled = Context.isFlyingCarpetAdEnabled('', cityName);
      }
      CustomEventService.triggerEvent('loadGoogleAds', false);
      updateInterstitialConfig('snbPWA');

      root.location.href = urlBuilder.getJobsSnbUrl(params);
      // }
      JobSnow.route = ROUTES.SNB;
      let isInterstialAdEnabledPrevious = JobSnow.isInterstialAdEnabled;
      JobSnow.isInterstialAdEnabled = Context.isInterstitialAdEnabled('snbPWA', cityName);
      JobSnow.isFlyingCarpetAdEnabled = Context.isFlyingCarpetAdEnabled('', cityName);
      // Event listening is required only when we move from a page (where interstitial ads were disabled) to a page (where interstitial ads are enabled).
      let isEventListeningRequired = (JobSnow.isInterstialAdEnabled && !isInterstialAdEnabledPrevious);
      CustomEventService.triggerEvent('loadGoogleAds', {
        isInitializeJobSnowRequired: false,
        isEventListeningRequired,
        isInterstitialAdEventDispatchRequired: false
      });
      updateInterstitialConfig('snbPWA');
    }
  }
}

function handleCandidateTestBackClick () {

  CandidateTestUtils.fireGAOnClose();
  CandidateTestUtils.redirect();
}

function getCurrentCity() {
  const cookies = new Cookies();
  return cookies.get('new_prefer_city') || 'www';
}

function getCurrentCityId() {
  const cookies = new Cookies();
  return cookies.get('prefer_city_id') || '1';
}

function getJKID() {
  const cookies = new Cookies();
  const jkidCookie = cookies.get('_jk_id') && cookies.get('_jk_id').split('.');
  return jkidCookie && jkidCookie[0];
}

function hideShellHeader() {
  const isAndroidRequest = root.location && new URLSearchParams(root.location.search).get('isAndroidRequest');
  return !isAndroidRequest;
}

function getAppPromotionDetails() {
  if(typeof navigator !== 'undefined' && navigator.userAgent.match(/Android/i)) {
    const {
      __PRELOADED_STATE__: {
        common: {
          showBanner = true
        } = {}
      } = {}
    } = window;

    return showBanner;
  }
  return null;
}

const jobsConfig = [
  {
    route: { path: HOME_PATH_REGEX, exact: true },
    sticky: true,
    international: true,
    header: {
      international: true,
      hasTitle: true,
      show: true,
      toolbarItems: (data) => [
        <MyAccountMenu key={'snb'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />,
        <Button onClick={handlePostAdClick} key="0" unelevated compact
                dense>Post Free Ad</Button>
      ],
      logoHref: '/jobs',
      hamburger: true,
      back: false,
      searchCityCallback: searchCityCallback
    },
    // ssr: true,
    actions: (dispatch, routeInfo, cookies) => {
      const params = {};

      const windowData = {
        locationPathname: routeInfo.url
      };
      const context = new Context();

      let actions = [
        // [dispatch(updateWindowData(windowData))],
        // context.initializeContextForHome(true, dispatch, cookies.cookies)
      ];
      return actions;
    },
    search: {
      show: true,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: true },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
    qrum: (location, match) => {
      let category = 'NA';
      if (typeof match !== 'undefined') {
        category = match && match.params && match.params.category;
      }
      const city = getCurrentCityId();
      const config = {
        PTYPE: getPageType('JOBS_SSR_HOME_MOBILE'),
        CAT: category,
        CITY: city,
        JKID: getJKID()
      };

      return config;
    }
  },
  {
    route: { path: SNB_PATH_REGEX, exact: true },
    international: true,
    header: {
      international: true,
      hasTitle: true,
      show: true,
      toolbarItems: (data) => [
        <MyAccountMenu key={'snb'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />,
        <Button onClick={handlePostAdClick} key="0" unelevated compact
                dense>Post Free Job</Button>
      ],
      logoHref: '/jobs',
      searchCityCallback: searchCityCallback,
      category: 'jobs',
      showBanner: getAppPromotionDetails(),
      gaPageType: 'SnB',
      viewinAppFAB: false
    },
    getCityNameFromRoute: (res, cookies, routeInfo) => {
      const urlBuilder = new UrlBuilder();
      const snbUrl = routeInfo.url.split('?')[0];
      const snbParams = urlBuilder.parseSnbUrl(snbUrl);
      if (snbParams.city && snbParams.city.length > 0) {
        return snbParams.city[0];
      } else { return 'www'; }
    },
    ssr: true,
    actions: (dispatch, routeInfo, cookies) => {
      const params = {};
      // const cityName = getCurrentCity();

      const windowData = {
        locationPathname: routeInfo.url
      };
      const urlBuilder = new UrlBuilder();
      const context = new Context();
      const cityRoleFilter = {};

      const snbUrl = routeInfo.url.split('?')[0];
      const snbParams = urlBuilder.parseSnbUrl(snbUrl);
      if (snbParams.role && snbParams.role.length > 0) {
        params.role = snbParams.role[0];
        cityRoleFilter.role = snbParams.role;
      }
      if (snbParams.city && snbParams.city.length > 0) {
        params.city = snbParams.city[0];
        cityRoleFilter.city = snbParams.city;
      }
      params.source = 'SNB';

      const defaultFiltersObj = copyObject(defaultFilters);
      const searchParams = setFiltersFromUrl(defaultFiltersObj, snbUrl, routeInfo.url);
      if (!searchParams.selectedFilters.city.length || !searchParams.selectedFilters.role.length) {
        cityRoleFilter.role = cityRoleFilter.role ? cityRoleFilter.role : [];
        cityRoleFilter.city = cityRoleFilter.city ? cityRoleFilter.city : [];
      }
      const defaultFilterLoadState = copyObject(searchParams);
      Object.assign(searchParams.selectedFilters, { page: 1 }, cityRoleFilter);

      let actions = [
        [dispatch(updateWindowData(windowData))],
        [dispatch(updateFilterState(defaultFilterLoadState))],
        context.initializeContext(params, true, dispatch, cookies.cookies),
        getSearchResultsPromise(searchParams.selectedFilters, null, true, dispatch, cookies.cookies)
      ];
      return actions;
    },
    search: {
      show: true,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: true },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
    qrum: (location, match) => {
      let category = 'NA';
      if (typeof match !== 'undefined') {
        category = match && match.params && match.params.category;
      }
      const city = getCurrentCityId();
      const config = {
        PTYPE: getPageType('JOBS_SSR_SNB_MOBILE'),
        CAT: category,
        CITY: city,
        JKID: getJKID()
      };

      return config;
    }
  },
  {
    route: { path: VAP_PATH_REGEX, exact: false },
    sticky: true,
    header: {
      international: true,
      hasTitle: true,
      show: true,
      toolbarItems: (data) => [
        <MyAccountMenu key={'vap'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />,
        <Button onClick={handlePostAdClick} key="0" unelevated compact
                dense >Post Free Job</Button>
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: true,
      handleBackClick: handleVapBackClick,
      searchCityCallback: searchCityCallback
    },
    ssr: true,
    actions: (dispatch, routeInfo, cookies) => {
      const data = {};
      let queryParams;
      if (routeInfo.params && routeInfo.params.queryParams) {
        queryParams = routeInfo.params.queryParams;
      }

      const windowData = {
        locationPathname: routeInfo.url
      };
      const urlBuilder = new UrlBuilder();
      const context = new Context();

      const jobId = urlBuilder.getJobIdFromVapUrl(routeInfo.url);
      let actions = [
        [dispatch(updateWindowData(windowData))],
        context.initializeContext({ jobId }, true, dispatch, cookies.cookies, queryParams)];
      return actions;
    },
    search: {
      show: true,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: true },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
    qrum: (location, match) => {
      let category = 'NA';
      if (typeof match !== 'undefined') {
        category = match && match.params && match.params.category;
      }
      const city = getCurrentCityId();
      const config = {
        PTYPE: getPageType('JOBS_SSR_VAP_MOBILE'),
        CAT: category,
        CITY: city,
        JKID: getJKID()
      };

      return config;
    }
  },
  {
    route: { path: GUARANTEEDJOBS_PATH_REGEX, exact: false },
    sticky: true,
    header: {
      international: true,
      hasTitle: false,
      show: true,
      hasLogo: false,
      toolbarItems: (data) => [
        <div class="mdc-toolbar__title gaurTitle">Guaranteed Job</div>
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: true,
      searchCityCallback: searchCityCallback
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      wallet: false
    },
    footer: { show: true },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
    qrum: (location, match) => {
      let category = 'NA';
      if (typeof match !== 'undefined') {
        category = match && match.params && match.params.category;
      }
      const city = getCurrentCityId();
      const config = {
        PTYPE: getPageType('JOBS_GUARANTEEDJOBS_MOBILE'),
        CAT: category,
        CITY: city,
        JKID: getJKID()
      };

      return config;
    }
  },
  {
    route: { path: POST_AD_S1_PATH_REGEX, exact: false },
    sticky: true,
    header: {
      international: true,
      hasTitle: false,
      show: hideShellHeader(),
      hasLogo: false,
      toolbarItems: (data) => [
        <div class="mdc-toolbar__title papTitle">Post Free Job In 30 Seconds</div>,
        <MyAccountMenu key={'snb'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: true,
      searchCityCallback: searchCityCallback
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      wallet: false
    },
    footer: { show: false },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
    qrum: (location, match) => {
      let category = 'NA';
      if (typeof match !== 'undefined') {
        category = match && match.params && match.params.category;
      }
      const city = getCurrentCityId();
      const config = {
        PTYPE: getPageType('JOBS_POST_AD_S1_MOBILE'),
        CAT: category,
        CITY: city,
        JKID: getJKID()
      };

      return config;
    }
  },
  {
    route: { path: RECRUITMENT_ASSIST_LINK_PATH_REGEX, exact: false },
    sticky: true,
    header: {
      international: true,
      hasTitle: false,
      show: true,
      hasLogo: false,
      toolbarItems: (data) => [
        <div class="mdc-toolbar__title shellTitle">Premium Services</div>,
        <MyAccountMenu key={'snb'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: true,
      searchCityCallback: searchCityCallback
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      wallet: false
    },
    footer: { show: true },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
    qrum: (location, match) => {
      let category = 'NA';
      if (typeof match !== 'undefined') {
        category = match && match.params && match.params.category;
      }
      const city = getCurrentCityId();
      const config = {
        PTYPE: getPageType('JOBS_RECRUITMENT_ASSIST_LINK_MOBILE'),
        CAT: category,
        CITY: city,
        JKID: getJKID()
      };

      return config;
    },
  },
  {
    route: { path: JOBS_404, exact: false },
    sticky: true,
    header: {
      international: true,
      hasTitle: true,
      show: true,
      toolbarItems: (data) => [
        <MyAccountMenu key={'404'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />,
        <Button onClick={handlePostAdClick} key="0" unelevated compact
                dense >Post Free Job</Button>
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: true,
      handleBackClick: handleVapBackClick,
      searchCityCallback: searchCityCallback
    },
    search: {
      show: true,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: true },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
  },
  {
    route: {
      path: CANDIDATE_TEST_LINK_PATH_REGEX,
      exact: true
    },
    sticky: true,
    header: {
      international: false,
      hasTitle: false,
      show: true,
      hasLogo: false,
      toolbarItems: (data) => [
        <div class="mdc-toolbar__title shellTitle">Survey</div>,
        <MyAccountMenu
          key="candidateTest"
          loggedOutMenu={LOGGEDOUT_MENU}
          loggedInMenu={LOGGEDIN_MENU}
          isLoggedIn={data.isLoggedIn}
        />
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: true,
      searchCityCallback: searchCityCallback,
      handleBackClick: handleCandidateTestBackClick
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults()
    },
    footer: {
      show: false
    },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
  },
  {
    route: { path: FLEXI_CANDIDATE_REGISTER, exact: false },
    sticky: true,
    header: {
      international: false,
      hasTitle: false,
      show: true,
      toolbarItems: (data) => [
        <MyAccountMenu key={'vap'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />,
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: false,
      handleBackClick: handleVapBackClick,
      searchCityCallback: searchCityCallback
    },
    // ssr: true,
    actions: (dispatch, routeInfo, cookies) => {
      let actions = [];
      return actions;
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: false },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
  },
  {
    route: { path: FLEXI_CANDIDATE_PROFILE, exact: false },
    sticky: true,
    header: {
      international: false,
      hasTitle: false,
      show: true,
      toolbarItems: (data) => [
        <MyAccountMenu key={'vap'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />,
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: false,
      handleBackClick: handleVapBackClick,
      searchCityCallback: searchCityCallback
    },
    // ssr: true,
    actions: (dispatch, routeInfo, cookies) => {
      let actions = [];
      return actions;
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: false },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
  },
  {
    route: { path: FLEXI_CANDIDATE_RMT_DATA_CAPTURE, exact: false },
    sticky: true,
    header: {
      international: false,
      hasTitle: false,
      show: true,
      toolbarItems: (data) => [
        <MyAccountMenu key={'vap'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />,
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: false,
      handleBackClick: handleVapBackClick,
      searchCityCallback: searchCityCallback
    },
    // ssr: true,
    actions: (dispatch, routeInfo, cookies) => {
      let actions = [];
      return actions;
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: false },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
  },
  {
    route: { path: FLEXI_RECRUITER_RMT_REPORT, exact: false },
    sticky: true,
    header: {
      international: true,
      hasTitle: true,
      show: true,
      toolbarItems: (data) => [
        <MyAccountMenu key={'vap'} loggedOutMenu={LOGGEDOUT_MENU} loggedInMenu={LOGGEDIN_MENU}
                       isLoggedIn={data.isLoggedIn} />,
      ],
      logoHref: '/jobs',
      hamburger: false,
      back: true,
      handleBackClick: handleVapBackClick,
      searchCityCallback: searchCityCallback
    },
    // ssr: true,
    actions: (dispatch, routeInfo, cookies) => {
      let actions = [];
      return actions;
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: false },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
  },
  {
    route: { path: UPGRADE_AD, exact: false },
    sticky: true,
    header: {
      international: false,
      hasTitle: false,
      show: true,
      toolbarItems: (data) => [<div class="mdc-toolbar__title shellTitle">Upgrade your free ad</div>],
      hasLogo: false,
      hamburger: false,
      back: true,
      handleBackClick: handleVapBackClick,
      searchCityCallback: searchCityCallback
    },
    // ssr: true,
    actions: (dispatch, routeInfo, cookies) => {
      let actions = [];
      return actions;
    },
    search: {
      show: false,
      placeholder: searchPlaceHolder(),
      onSearchSubmit: onSearchSubmit,
      onSearchCallback: onSearchCallback,
      searchSuggestions: getCustomSearchResults(),
      showTrendingSearches: false,
      wallet: false
    },
    footer: { show: false },
    ga: {accountId: GA_ACCOUNT_ID, trackerName: GA_TRACKER_NAME},
  }
];

export default jobsConfig;



// WEBPACK FOOTER //
// ../q-jobs/src/shellConfig.js